/* * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights
Reserved. * * Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with * the License. A copy of the
License is located at * * http://aws.amazon.com/apache2.0/ * * or in the
"license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR * CONDITIONS OF ANY KIND, either express or
implied. See the License for the specific language governing permissions * and
limitations under the License. */

<template>
  <ValidationObserver ref="obs" v-slot="{ invalid, validated }">
    <v-card max-width="350" color="transparent" :elevation="0">
      <v-alert
        v-if="alert.message"
        v-model="alert.show"
        prominent
        dense
        dismissible
        :type="alert.type || 'error'"
        transition="scale-transition"
      >
        <v-layout align-center wrap>
          <div>
            {{ alert.message }}
          </div>
        </v-layout>
      </v-alert>
      <v-card-text>
        <form>
          <ValidationProvider
            :label="`${$Amplify.I18n.get('Old Password')}`"
            rules="required"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              autofocus
              v-model="oldPassword"
              :placeholder="$Amplify.I18n.get('Enter your current password')"
              :label="`${$Amplify.I18n.get('Old Password')} *`"
              :append-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="passwordVisible = !passwordVisible"
              :type="passwordVisible ? 'text' : 'password'"
              :error-messages="errors"
              :success="valid"
            ></v-text-field>
          </ValidationProvider>

          <ValidationProvider
            :label="`${$Amplify.I18n.get('New Password')}`"
            rules="required"
            v-slot="{ errors, valid }"
          >
            <v-text-field
              v-model="newPassword"
              :placeholder="$Amplify.I18n.get('Enter your new password')"
              :label="`${$Amplify.I18n.get('New Password')} *`"
              :append-icon="passwordVisible ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="passwordVisible = !passwordVisible"
              :type="passwordVisible ? 'text' : 'password'"
              v-on:keyup.enter="submit"
              :error-messages="errors"
              :success="valid"
            ></v-text-field>
          </ValidationProvider>
        </form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-on:click="submit"
          color="primary"
          :disabled="invalid || !validated || loadingBtn"
          :loading="loadingBtn"
        >
          {{ $Amplify.I18n.get("Submit") }}
          <template v-slot:loader>
            <span>{{ $Amplify.I18n.get("Wait...") }}</span>
          </template>
        </v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "ChangePassword",
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: ["forgotPasswordConfig"],
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      passwordVisible: false,
      logger: {},
      alert: {
        show: false,
        type: "",
        message: ""
      },
      loadingBtn: false
    };
  },
  computed: {
    options() {
      const defaults = {
        header: this.$Amplify.I18n.get("Change Password")
      };
      return Object.assign(defaults, this.forgotPasswordConfig || {});
    }
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    submit: function() {
      this.resetAlert();
      this.loadingBtn = true;
      this.$Amplify.Auth.currentAuthenticatedUser()
        .then(user => {
          return this.$Amplify.Auth.changePassword(
            user,
            this.oldPassword,
            this.newPassword
          );
        })
        .then(data => {
          this.loadingBtn = false;
          this.setAlert({
            message: this.$Amplify.I18n.get("Your password has been updated"),
            type: "success"
          });
          console.log(data);
        })
        .catch(e => {
          this.setError(e);
        });
    },
    setError: function(e) {
      this.loadingBtn = false;
      this.error = this.$Amplify.I18n.get(e.message || e);
      this.setAlert({ message: this.error });
      this.logger.error(this.error);
    },
    setAlert: function({ message, type = "error", show = true }) {
      this.alert = {
        message,
        type,
        show
      };
    },
    resetAlert: function() {
      this.setAlert({
        message: "",
        show: false
      });
    }
  }
};
</script>
